// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export interface BaseSettings {
    enable: string;
}

export interface CheqSettings extends BaseSettings {
    cheqIframeSource: string;
    cheqScriptClass: string;
    cheqScriptDataCh: string;
    cheqScriptUri: string;
}

export interface OneTrustSettings extends BaseSettings {
    dataDomainScript: string;
    oneTrustSource: string;
}

export const injectElementAttributes = (element: Element, attributes: { [key: string]: string }) => {
    Object.keys(attributes).forEach(key => {
        element.setAttribute(key, attributes[key]);
    });
};

export const shouldGenerateScript = (scriptSettings: BaseSettings) => {
    return scriptSettings && scriptSettings.enable.toLowerCase() === "true";
};

export interface AmazonConnectChatSettings extends BaseSettings {
    amazonChatSource: string;
    amazonChatTokenCachingTimeInMinutes: string;
    amazonConnectId: string;
    secretKey: string;
    snippetId: string;
    widgetId: string;
}